import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { SettingResponse, SettingsResponse } from "./SettingsTypes"
const ENDPOINT_SETTINGS = "settings";

const getSettings =  (token: string) => {
  const settingsResult = genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_SETTINGS as string,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as SettingsResponse)
  return settingsResult;
};

const getSettingByName = (token: string, nameSetting: string) => {
  const endpoint = `${ENDPOINT_SETTINGS}/name/${nameSetting}`;

  const settingsResult = genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as SettingResponse);
  return settingsResult;
};

export { getSettings, getSettingByName };
